import { render, staticRenderFns } from "./TemplateCopyModal.vue?vue&type=template&id=bd2cf8c4&scoped=true&"
import script from "./TemplateCopyModal.vue?vue&type=script&lang=js&"
export * from "./TemplateCopyModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCopyModal.vue?vue&type=style&index=0&id=bd2cf8c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2cf8c4",
  null
  
)

export default component.exports